/**
 * Validates a phone number in the format (XXX) XXX-XXXX
 * This matches the format produced by the PhoneInput component from @cleverrealestate/clever-bricks
 * Follows North American Numbering Plan (NANP) rules:
 * - Area code cannot start with 0 or 1
 * - Exchange code (middle 3 digits) cannot start with 0 or 1
 * @param phone - The phone string to validate
 * @returns boolean - true if valid, false otherwise
 */
export const validatePhone = (phone: string): boolean => {
  if (!phone || phone.trim() === '') {
    return false;
  }

  const phoneRegex = /^\([2-9]\d{2}\) [2-9]\d{2}-\d{4}$/;
  return phoneRegex.test(phone);
};
